import React from "react";
import { withStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import Gist from "react-gist";
import Link from "@material-ui/core/Link";
import ReactPlayer from "react-player";
import Markdown from "markdown-to-jsx";

/* eslint import/no-webpack-loader-syntax: off */
import mdcon from "!raw-loader!./mdconfig.md";
import rc from "!raw-loader!./rc.md";
import sfc from "!raw-loader!./sfc.md";
import hj from "!raw-loader!./hj.md";

const styles = theme => ({
  card: {
    minWidth: 275
  },
  para: {
    fontSize: 16
  },
  imgdiv: {
    textAlign: "center",
    margin: "10px"
  },
  img: {
    borderRadius: "8px",
    border: "1px solid gray",
    maxWidth: "80%"
  },
  bullet: {
    display: "inline-block",
    margin: "0 2px",
    transform: "scale(0.8)"
  },
  title: {
    fontSize: 14
  },
  pos: {
    marginBottom: 12
  },
  root: {
    width: "100%"
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: theme.typography.fontWeightRegular
  }
});

const webdev = props => {
  const { classes } = props;
  const mdconfig = {
    overrides: {
      ReactPlayer: {
        component: ReactPlayer
      },
      h1: {
        component: Typography,
        props: {
          variant: "h5"
        }
      },
      h2: {
        component: Typography,
        props: {
          variant: "h6"
        }
      },
      h3: {
        component: Typography,
        props: {
          variant: "h6",
          color: "textSecondary",
          className: classes.para
        }
      },
      a: {
        component: Link,
        props: {
          target: "_blank"
        }
      },
      p: {
        component: Typography,
        props: {
          paragraph: true,
          className: classes.para
        }
      },
      ul: {
        component: Typography,
        props: {
          component: "ul",
          className: classes.para
        }
      },
      em: {
        props: {
          className: classes.para
        }
      },
      pre: {
        props: {
          // className: "w3-panel w3-card w3-light-grey"
          className: "w3-card "
        }
      },
      code: {
        props: {
          className: "w3-code jsHigh notranslate"
        }
      }
    }
  };
  return (
    <div>
      <Typography variant="h5" color="primary">GitLab hosting</Typography>
      <Typography className={classes.para} paragraph>
        GitLab Pages only supports static websites, meaning, the output files
        must be HTML, CSS, and JavaScript only. The default{" "}
        <Link color="secondary" href="https://www.mkdocs.org/" target="_blank">
          mkdocs
        </Link>{" "}
        provided by fabacademy is also a static website that uses python to
        generate HTML,CSS and JS files. The CI/CD feature of gitlab makes
        hosting mkdocs like static sites easy by running scripts of different
        programming environment like Python, NodeJS for deployment stage.
        <br />
        I've used ReactJS for my website.
      </Typography>
      <Typography variant="h5" color="primary">React App</Typography>
      <Typography className={classes.para} paragraph>
        I had prior experience with HTML,CSS,JS and Bootstrap. I was exploring
        ReactJs recently as it is the most popular framework now for creating
        amazing user experience for WebApps. So, I decided to use ReactJs for
        making my website. ReactJs is a JavaScript library for building user
        interfaces developed by Facebook. It has a small API with declarative UI
        paradigm. It simplifies event handling and updating data. This works by
        updating Virtual DOM when there is any change. ReactJS reacts to change
        efficiently. The real DOM is modified by React, specifically targeting
        the element that changed. This makes it efficient for handling complex
        UI web apps.
      </Typography>
      <Typography variant="h5" color="primary"> creat-react-app</Typography>
      <Typography className={classes.para} paragraph>
        'creat-react-app' is React App Template that provides an easy way to get
        started on developing React App without manually setting up build tools.
        <br />I installed NodeJS first form{" "}
        <Link color="secondary" target="_blank" href="https://nodejs.org/">
          Nodejs.org
        </Link>
        <br />
        Then I installed 'create-react-app' module by following command.
        <br />
        <code className="w3-codespan">npm i create-react-app</code>
        <br />
        Then I created a React App by following command.
        <br />
        <code className="w3-codespan">create-react-app fabacademy2019</code>
        <br />
        Then I started development server by following command.
        <br />
        <code className="w3-codespan">cd fabacademy2019</code>
        <br />
        <code className="w3-codespan">npm start</code>
        <br />
      </Typography>
      <div className={classes.imgdiv}>
        <img
          className={classes.img}
          src="./react_dev_cmd.png"
          alt="Schematic"
        />
      </div>
      <Typography className={classes.para} paragraph>
        The development server provides live-reloading feature. So, the changes
        made to project files is reflected in the web browser right away. The
        changes are compiled and react app is reloaded. However, live-reloading
        is different from hot-reloading. Although hot-reloading is not available
        with the create-react-app I choose to use this bundle as it is
        recommended for react app beginners like me.
        <br />
        <Typography className={classes.para} paragraph>
          <Typography variant="h5" color="primary">
            .gitlab-ci.yml file configuration
          </Typography>
          <Typography className={classes.para} paragraph>
            I used the following yml configuration for reactjs app. The script
            checks and installs dependencies every time I push to repo. It also
            cache the node_modules folder for quick deployment.
          </Typography>{" "}
          <div>
            <Gist id="be658426bd1663a133f5b1cb4b552d63" file=".gitlab-ci.yml" />
          </div>{" "}
          <Typography className={classes.para} paragraph />
          <Typography variant="h5" color="primary">CI/CD pipelines</Typography>
          <Typography className={classes.para} paragraph>
            CI/CD feature makes it really easy to run test, build and deploy
            scripts in remote system, while keeping only development version in
            local system.
          </Typography>{" "}
        </Typography>{" "}
        <div className={classes.imgdiv}>
          <img className={classes.img} src="./ci_jobs.png" alt="Schematic" />
        </div>{" "}
        <Typography className={classes.para} paragraph>
          I tried to test if the ReactJS is working with this yml configuration.
          Then I got the following result to confirm.
        </Typography>{" "}
        <div className={classes.imgdiv}>
          <img
            className={classes.img}
            src="./react_working_on gitlab.png"
            alt="Schematic"
          />
        </div>{" "}
        <Typography className={classes.para} paragraph />
        <Typography variant="h5" color="primary">Developer Environment</Typography>
        Developer tools are necessary for code readability and maintaining
        consistency in coding style.
        <Typography variant="h6">Visual Studio Code - Editor</Typography>
        <Typography className={classes.para} paragraph>
          VS code is one of the most popular editors out there. I've seen a
          number of developers using VS Code on YouTube tutorials. I like it a
          lot for number of reasons.
        </Typography>
        <Typography className={classes.para} paragraph>
          <Typography className={classes.para} variant="h6">
            1. Extensions
          </Typography>
          VS code has a large number of useful extensions which make developer
          life easier. I've used the following extensions for my react app
          development.
        </Typography>{" "}
        <div className={classes.imgdiv}>
          <img
            className={classes.img}
            src="./WebDev/Screenshot_1.png"
            alt="Schematic"
          />
        </div>{" "}
        <Typography className={classes.para} paragraph />{" "}
        <div className={classes.imgdiv}>
          <img
            className={classes.img}
            src="./WebDev/Screenshot_2.png"
            alt="Schematic"
          />
        </div>{" "}
        <Typography className={classes.para} paragraph />{" "}
        <div className={classes.imgdiv}>
          <img
            className={classes.img}
            src="./WebDev/Screenshot_3.png"
            alt="Schematic"
          />
        </div>{" "}
        <Typography className={classes.para} paragraph />{" "}
        <div className={classes.imgdiv}>
          <img
            className={classes.img}
            src="./WebDev/Screenshot_4.png"
            alt="Schematic"
          />
        </div>{" "}
        <Typography className={classes.para} paragraph>
          <Typography className={classes.para} variant="h6">
            2. GIT Integration
          </Typography>
          VS Code also provides git utility as part of user experience. So,
          without leaving the editor all git operations can be performed.
        </Typography>{" "}
        <div className={classes.imgdiv}>
          <img
            className={classes.img}
            src="./WebDev/Screenshot_5.png"
            alt="Schematic"
          />
        </div>{" "}
        <Typography className={classes.para} paragraph />
        <Typography variant="h5" color="primary">App Development</Typography>
        <Typography className={classes.para} paragraph>
          I wanted a responsive mobile webapp. Also, I like Google's Material
          Design. I explored the{" "}
          <Link color="secondary"
            rel="noopener noreferrer"
            target="_blank"
            href={"https://material-ui.com/"}
          >
            material-ui
          </Link>{" "}
          react components to get the desired result. I started with the
          component demo pages. I picked the "Responsive Drawer" from{" "}
          <Link color="secondary"
            href={"https://material-ui.com/demos/drawers/"}
            target="_blank"
            rel="noopener noreferrer"
          >
            Drawer Demo
          </Link>
          .
        </Typography>
        <div className={classes.imgdiv}>
          <img
            className={classes.img}
            src="./responsive_drawer.png"
            alt="Schematic"
          />
        </div>
        <Typography className={classes.para} paragraph>
          I used this as my root component in <code>App.js</code>. I've used{" "}
          <Link color="secondary"
            href={"https://material-ui.com/demos/expansion-panels/"}
            target="_blank"
            rel="noopener noreferrer"
          >
            expansion-panels
          </Link>
          ,{" "}
          <Link color="secondary"
            href={"https://material-ui.com/demos/lists/#nested-list"}
            target="_blank"
            rel="noopener noreferrer"
          >
            nested-list
          </Link>
          ,{" "}
          <Link color="secondary"
            href={"https://material-ui.com/demos/cards/"}
            target="_blank"
            rel="noopener noreferrer"
          >
            cards
          </Link>{" "}
          etc. components to design the UI.
          <br />I tried to choose most apt{" "}
          <Link color="secondary"
            href={"https://material.io/tools/icons/"}
            target="_blank"
            rel="noopener noreferrer"
          >
            material icons
          </Link>{" "}
          and corresponding material-ui{" "}
          <Link color="secondary"
            href="https://material-ui.com/style/icons/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Icon components
          </Link>{" "}
          to represent the sidebar menu items.
        </Typography>
        The current version of website appears as follows.
        <br />
      </Typography>
      <div className={classes.imgdiv}>
        <img className={classes.img} src="./react_dev.png" alt="Schematic" />
      </div>{" "}
      <Typography variant="h5" color="primary">Mobile Interface</Typography>
      <Typography className={classes.para}>
        In Mobile View the website looks as follows.
      </Typography>
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "space-evenly"
        }}
      >
        <div className={classes.imgdiv}>
          <img
            className={classes.img}
            src="./mobile_view-2.png"
            alt="Schematic"
          />
        </div>
        <div className={classes.imgdiv}>
          <img
            className={classes.img}
            src="./mobile_view-3.png"
            alt="Schematic"
          />{" "}
        </div>{" "}
      </div>
      <Typography className={classes.para} paragraph>
        I've added{" "}
        <Link color="secondary" href={"https://material-ui.com/api/swipeable-drawer/"}>
          Swipeable Drawer{" "}
        </Link>{" "}
        component to make it convenient for mobile users. ReactJs also makes it
        easy to create Progressive Web Apps (PWA). I've updated the default
        manifesto file to desired App name and description.
      </Typography>
      <Typography variant="h5" color="primary">React Code</Typography>
      <Typography className={classes.para} paragraph>
        React App is made of components. The ReactJS framework allows us to
        define custom components and reuse them anywhere we like. Every
        component has a memory called 'state' and a way to receive data from
        parent components thorough 'props'. These features allow us to
        communicate between components. Events can trigger custom helper
        functions to change 'state' of components.
        <br />
        There are sophisticated ways to manage all the state of components
        centrally as well but I've not tried those yet, such as{" "}
        <Link color="secondary" href="" target="_blank">
          Redux.
        </Link>
      </Typography>
      <Markdown options={mdconfig}>{rc}</Markdown>
      <Markdown options={mdconfig}>{sfc}</Markdown>
      <Typography variant="h5" color="primary">Highlight current selection.</Typography>
      <Typography className={classes.para} paragraph>
        I used 'selected' props in{" "}
        <Link color="secondary" href={"https://material-ui.com/api/list-item/"}>list-item</Link>{" "}
        to apply selection styling.
      </Typography>
      <div className={classes.imgdiv}>
        <img
          className={classes.img}
          src="./WebDev/Screenshot_6.png"
          alt="Schematic"
        />
      </div>{" "}
      <div className={classes.imgdiv}>
        <img
          className={classes.img}
          src="./WebDev/Screenshot_7.png"
          alt="Schematic"
        />
      </div>{" "}
      <Typography variant="h5" color="primary">Problem with Virtual DOM</Typography>
      <Typography className={classes.para} paragraph>
        I couldn't embed gitlab.com snippets as the code provided by gitlab
        injects html/css by modifying real DOM. I used github gist to host
        snippets and used{" "}
        <Link color="secondary"
          href={"https://www.npmjs.com/package/react-gist"}
          target="_blank"
          rel="noopener noreferrer"
        >
          react-embed-gist
        </Link>{" "}
        module to embed code snippets. Later I implemented markdown-to-jsx
        component and added Javascript library to highlight code snippets.
        <Markdown options={mdconfig}>{hj}</Markdown>
      </Typography>
      <Typography variant="h5" color="primary">Disqus Comments Setup</Typography>
      <div className={classes.imgdiv}>
        <img
          className={classes.img}
          src="./WebDev/Screenshot_8.png"
          alt="Schematic"
        />
      </div>{" "}
      <Typography className={classes.para} paragraph>
        I used{" "}
        <Link color="secondary" href={"https://github.com/disqus/disqus-react"} target="_blank">
          disqus-react
        </Link>{" "}
        for adding comment feature to my website.
      </Typography>
      <Typography variant="h6">Page Title</Typography>
      <Typography className={classes.para} paragraph>
        I used{" "}
        <Link color="secondary" href={"https://github.com/nfl/react-helmet"}>react-helmet</Link>{" "}
        to update page title dynamically for every page. This became necessary
        as Disqus fourm registers the page title and URL with each comment.
        Prior to this change all pages had same title.
      </Typography>
      <Typography variant="h6">Markdown</Typography>
      <Typography className={classes.para} paragraph>
        I eventually realized that writing documentation with all these web tags
        slowing me down. I wanted to use MarkDown. I found{" "}
        <Link color="secondary"
          href="
        https://www.npmjs.com/package/markdown-to-jsx"
          target="_blank"
        >
          markdown-to-jsx
        </Link>{" "}
        ReactJS component for parsing the MarkDown file to JSX format.
      </Typography>
      <Markdown options={mdconfig}>{mdcon}</Markdown>
    </div>
  );
};

export default withStyles(styles)(webdev);
